export const UPDATE_ROUTE_HISTORY = 'UPDATE_ROUTE_HISTORY'
export const CLEAR_ROUTE_HISTORY = 'CLEAR_ROUTE_HISTORY'
